'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');

var _constants = require('../../constants');

var _Video = require('./Video.scss');var styles = _interopRequireWildcard(_Video);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Styles
// Modules
var Video = function Video(props) {
  // TODO Uncomment for Home page video
  // const content = (properties.isMobileOrTablet)
  //   ? (<div className={styles.imgCover}>
  //     <img src={headerVideo.preloaderJpg} alt="" />
  //   </div>)
  //   : (<video
  //     loop
  //     autoPlay
  //     controls={false}
  //     poster={headerVideo.preloaderJpg}
  //     onContextMenu={event => event.preventDefault()}
  //   >
  //     <source src={headerVideo.mp4} type="video/mp4" />
  //     <source src={headerVideo.ogv} type="video/ogv" />
  //     <source src={headerVideo.webm} type="video/webm" />
  //   </video>);

  var renderContent = function renderContent() {return (
      _react2.default.createElement('div', {
        className: styles.imgCover,
        style: {
          backgroundImage: 'url(' + (props.imageLink || (props.isMobileOrTablet ? _constants.homePageImageMobile : _constants.homePageImage)) + ')' } }));};






  return (
    _react2.default.createElement('div', { className: styles.header_video_container },
      renderContent()));


}; // Helpers

Video.propTypes = {
  isMobileOrTablet: _propTypes2.default.bool,
  imageLink: _propTypes2.default.string };exports.default =


Video;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Video/Video.js
// module id = 2955
// module chunks = 0